import { LayoutGrid } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import LookoutServicesIcon from "../../../assets/images/lookout-services.svg";
import DIFAIcon from "../../../assets/images/difa.svg";

const AppsMenu = ({
  isOpen,
  onClose,
  isInternalUser,
}: {
  isOpen: boolean;
  onClose: () => void;
  isInternalUser: boolean;
}) => {
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [hoveredApp, setHoveredApp] = useState<string | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: { target: any }) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);
  
  const appItems = [
    {
      icon: (
        <div className="w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:bg-slate-700/50 bg-[rgb(30 41 59 / 0.5)]">
          <img
            src={DIFAIcon}
            alt="DIFA"
            className="transform transition-all duration-500 group-hover:scale-110 w-12 h-12"
          />
        </div>
      ),
      name: "DIFA",
      description: "reliability services",
      path: process.env.REACT_APP_DIFA_URL,
      hoverEffect: "bg-[#475569]", //"bg-gradient-to-br from-slate-600/20 to-slate-800/20",
    },
    {
      icon: (
        <div className="w-12 h-12 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:bg-slate-700/50 bg-[rgb(30 41 59 / 0.5)]">
          <img
            src={LookoutServicesIcon}
            alt="LOOKOUT™"
            className="transform transition-all duration-500 group-hover:scale-110 w-12 h-12"
          />
        </div>
      ),
      name: "LOOKOUT™",
      description: "optimization services",
      path: process.env.REACT_APP_LOOKOUT_URL,
      hoverEffect: "bg-[#475569]", //"bg-gradient-to-br from-slate-600/20 to-slate-800/20",
    },
  ];

  return (
    <div
      ref={menuRef}
      className={`fixed bottom-0 ${
        isInternalUser ? "w-[450px]" : "w-80"
      } bg-slate-700 rounded-2xl shadow-2xl p-4 z-50 left-[78px] md:bottom-24
        ${
          isOpen
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-8 pointer-events-none"
        }
        transition-all duration-300 ease-in-out`}
      style={{ bottom: "" }}
    >
      <div
        onClick={() =>
          window.open(
            `${process.env.REACT_APP_ESP_ECOSYSYEM_URL}esp-all-apps`,
            "_blank"
          )
        }
        className="flex flex-col items-center px-5 py-4  bg-[#4A5463] rounded-lg cursor-pointer hover:bg-[#475569]"
      >
        <LayoutGrid className="w-6 h-6 text-white" />
        <h3 className="text-white text-xs mt-2">All apps</h3>
      </div>

      <div
        className={`grid ${
          isInternalUser ? "grid-cols-3" : "grid-cols-2"
        } gap-2 p-4`}
      >
        {appItems.map((app, index) => (
          <div
            key={index}
            className="flex flex-col items-center cursor-pointer rounded-xl p-6 transition-all duration-300 relative overflow-hidden hover:bg-[#475569]"
            onClick={() => window.open(app.path, "_blank")}
            onMouseEnter={() => setHoveredApp(app.name)}
            onMouseLeave={() => setHoveredApp(null)}
          >
            <div className="absolute inset-0 bg-slate-800 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl" />
            <div
              className={`absolute inset-0 ${app.hoverEffect} opacity-0 group-hover:opacity-100 transition-all duration-500 rounded-xl`}
            />
            <div
              className={`relative z-10 transform transition-all duration-500 ${
                hoveredApp === app.name ? "scale-110" : ""
              }`}
            >
              {app.icon}
            </div>
            <div className="w-full relative z-10 text-center mt-2">
              <p className="text-white text-sm font-medium">{app.name}</p>
              {app.description && (
                <p className="text-xs text-center text-white mt-1">
                  {app.description}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppsMenu;
